<div class="alarm-actions" [ngStyle]="{ 'flex-direction': reversed ? 'row-reverse' : 'row'}">
  <div
    [ngClass]="{'train-number': true, 'dark-background': darkBtn}"
    (click)="openDetails(
      $event,
      trainDate,
      tripNumber
    )">
    {{ trainCategory }} {{ tripNumber }}
  </div>

    <div class="btn-wrapper">
      <fa-icon
        *ngIf="isTrainOnMap"
        icon="crosshairs"
        [ngStyle]="{ cursor: 'pointer' }"
        (click)="focusMarker(trainDate, tripNumber)">
      </fa-icon>
  </div>
</div>